import React from 'react';
import DynamicIcon from '@bvt-icons';
import { useMainMap } from '@bvt-features/mainmap/mainmap/hook/useMainMap';
import { useMap } from 'react-leaflet';
import { LayoutMainMapRightSide } from '@bvt-features/mainmap/mainmap/component/LayoutMainMapRightSide';

import './PertaminaGrianaContainer.scss';
import { PertaminaListGrianaContainer } from '../PertaminaListGrianaContainer';
import { PertaminaResultGrianaContainer } from '../PertaminaResultGrianaContainer';
import { usePertaminaGriana } from '@bvt-features/pertamina/hooks/usePertaminaGriana';

export const PertaminaGrianaContainer = () => {
  const initialmap = useMap();
  const mainMap = useMainMap();
  const { projectDetail, setProjectDetail } = usePertaminaGriana();
  const isActive = mainMap.state.activeMenu === 'GRIANA_PERTAMINA';

  if (!isActive) {
    return null;
  }

  const handleClose = () => {
    mainMap.setActiveMenu(undefined);
    setProjectDetail({ processID: null, projectID: null });
  };

  const internalDisableHandleMapEvent = (param) => {
    if (param) {
      initialmap.scrollWheelZoom.disable();
      initialmap.doubleClickZoom.disable();
      initialmap.dragging.disable();
    } else {
      initialmap.scrollWheelZoom.enable();
      initialmap.doubleClickZoom.enable();
      initialmap.dragging.enable();
    }
  };

  return (
    <LayoutMainMapRightSide
      height={'100vh'}
      isActive={isActive}
      onMouseEnter={() => internalDisableHandleMapEvent(true)}
      onMouseLeave={() => internalDisableHandleMapEvent(false)}
      top='8rem'
      width={mainMap.state.activeMenuWidth}
    >
      <div className='PertaminaGrianaContainer'>
        <div className='PertaminaGrianaContainer--header'>
          <span className='title'>Grid Analysis{projectDetail.name ? ` - ${projectDetail.name}` : ''}</span>
          <button className='button' onClick={handleClose}>
            <DynamicIcon icon='close' />
          </button>
        </div>
        <div className='PertaminaGrianaContainer--body'>
          {projectDetail.processID && projectDetail.projectID ? (
            <PertaminaResultGrianaContainer
              {...projectDetail}
              onBack={() => setProjectDetail({ processID: null, projectID: null, name: '' })}
            />
          ) : (
            <PertaminaListGrianaContainer onClick={(v) => setProjectDetail(v)} />
          )}
        </div>
      </div>
    </LayoutMainMapRightSide>
  );
};
